import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Empty_Unit_Interface, Unit_Interface } from 'src/app/Interface/Unit_Interface';
import { Empty_QUANTITY_Interface, QUANTITY_Interface } from 'src/app/Interface/QUANTITY_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { UnitService } from 'src/app/Service/Unit/Unit.service';

@Component({
  selector: 'app-UnitEdit',
  templateUrl: './UnitEdit.component.html',
  styleUrls: ['./UnitEdit.component.css']
})
export class UnitEditComponent implements OnInit {

  Data_Seleted_Record:QUANTITY_Interface=Empty_QUANTITY_Interface()
  Token:String=""
  EditRecord:Number

  constructor(
    private Unit_Service:UnitService,
    private Alertify_Service:AlertifyService,
    private Nav_Service:NavService,
    private route: ActivatedRoute
  ) { }
  ngOnInit() {
    this.Token=localStorage.getItem('Daro_User_Token');
    this.EditUnit=new FormGroup({
      id :new FormControl(),
      Title:new FormControl(null,Validators.required),
    })

    this.EditRecord = Number(this.route.snapshot.paramMap.get('id'))


    this.Nav_Service.CheckValidPage(this.Token,48).subscribe(
      data=>{
        this.Unit_Service.GetSingle(this.Token,this.EditRecord).subscribe(
          data=>{
            this.get_Form_Id().setValue(data.id)
            this.get_Form_Title().setValue(data.title)
            this.Data_Seleted_Record.title=data.quantity_title
          }
        )
      }
      ,error=>{
        localStorage.clear()
        location.reload();
      }
    )

  }

    //#region  Form Add

    EditUnit:FormGroup;

    get_Form_Id(){
      return this.EditUnit.get('id') as FormControl;
    }

    get_Form_Title(){
      return this.EditUnit.get('Title') as FormControl;
    }

    //#endregion

    InProccessing:boolean=false

    SubmitEditUnit(){
      var Record:Unit_Interface =Empty_Unit_Interface()
      Record.id=this.get_Form_Id().value
      Record.title=this.get_Form_Title().value
      this.InProccessing=true
      this.Unit_Service.EditUnit(Record,this.Token).subscribe(
        data=>{
          this.InProccessing=false
          if(data.id==-2){
            this.Alertify_Service.ErrorMessage("The entered title already exists in the list.")
          }
          else{

            this.Alertify_Service.SuccessMessage("Information saved successfully.")
          }
        }
      )
    }



}
